import React, { useEffect } from "react";
import { useSystemPropertiesFilter } from "../../../state/FilterContext";
import { useArrayContext } from "../../../state/ArrayContext";
import { SourceItem } from "../../../shared/models/source-item.model";
import { PropertiesModel } from "../../../shared/models/metadata.model";

/***
 * Array source that returns the names of a filter for a system property.
 * 
 * Params:
 *    property: the name of the system property
 */
export const SystemPropertyFilterNames = React.memo(function SystemPropertyFilterNames(): React.ReactElement {
    const { setArray } = useArrayContext();
    const systemProperties: PropertiesModel = useSystemPropertiesFilter();

    useEffect(() => {
        let names: Array<SourceItem> = [];
        names = Object.keys(systemProperties || {}).map((name: string, ix: number) => {
            return {
                value: name,
                props: {},
                position: ix + 1,
            };
        }) || [];
        setArray(names);
    }, [systemProperties, setArray]);

    return <></>;
});